import type { IValidator } from './IValidator';

export class DayValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    validGenderValues: string[] = [];

    public constructor() {}
    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        if (Number.isNaN(parseInt(cellvalue))) {
            this.status = 'dayvalidator.unknownday';
            this.statusType = 'error';
            return false;
        }
        const day = parseInt(cellvalue);

        if (day < 1 || day > 31) {
            this.status = 'dayvalidator.invalidday';
            this.statusType = 'error';
            return false;
        }

        return true;
    }
}
